import { CommonModule } from '@angular/common';
import { HttpClient, HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { AngularFireModule } from '@angular/fire/compat';
import { SETTINGS } from '@angular/fire/compat/firestore';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { MsalGuard, MsalInterceptor, MsalModule, MsalRedirectComponent } from '@azure/msal-angular';
import { registerTranslateExtension } from '@core';
import {
  EntryFormComponent,
  HomeComponent,
  LoginComponent,
  SuccessScreenComponent,
  UserPreferencesComponent,
} from '@features';
import { HomeLayoutComponent, MainLayoutComponent } from '@layouts';
import { FormlyBootstrapModule } from '@ngx-formly/bootstrap';
import { FormlyModule, FORMLY_CONFIG } from '@ngx-formly/core';
import { TranslateLoader, TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  CheckboxTypeComponent,
  InputTypeComponent,
  InputWithHelperTypeComponent,
  PhoneTypeComponent,
  RadiobuttonTypeComponent,
  SectionTitleComponent,
  SelectTypeComponent,
  SharedModule,
  ShipmentIdentifierTableTypeComponent,
  SpinnerComponent,
  TextareaTypeComponent,
  TimepickerTypeComponent,
  ToggleTypeComponent,
} from '@shared';
import { NglModule } from 'ng-lightning';
import { NgxIntlTelInputModule } from 'ngx-intl-tel-input';
import {
  AZURE_AUTH_REQUEST,
  AZURE_PROTECTED_RESOURCE_MAP,
  AZURE_PUBLIC_CLIENT_APP,
} from 'src/config/azure-auth.config';
import { FORMLY_CUSTOM_CONFIG } from 'src/config/formly.config';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpLoaderFactory } from './app.httpLoaderFactory';
import { SearchCasesComponent } from './features/home/search-cases/search-cases.component';

@NgModule({
  declarations: [
    AppComponent,
    CheckboxTypeComponent,
    EntryFormComponent,
    HomeComponent,
    HomeLayoutComponent,
    InputTypeComponent,
    InputWithHelperTypeComponent,
    LoginComponent,
    MainLayoutComponent,
    PhoneTypeComponent,
    RadiobuttonTypeComponent,
    SectionTitleComponent,
    SelectTypeComponent,
    ShipmentIdentifierTableTypeComponent,
    SpinnerComponent,
    SuccessScreenComponent,
    TextareaTypeComponent,
    TimepickerTypeComponent,
    ToggleTypeComponent,
    UserPreferencesComponent,
    SearchCasesComponent,
  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    FormlyBootstrapModule,
    FormlyModule.forRoot(FORMLY_CUSTOM_CONFIG),
    HttpClientModule,
    HttpClientModule,
    MsalModule.forRoot(AZURE_PUBLIC_CLIENT_APP, AZURE_AUTH_REQUEST, AZURE_PROTECTED_RESOURCE_MAP),
    NglModule,
    ReactiveFormsModule,
    RouterModule,
    SharedModule,
    FormsModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    AngularFireModule.initializeApp(environment.firebase),
    NgxIntlTelInputModule,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS, // Provides as HTTP Interceptor
      useClass: MsalInterceptor,
      multi: true,
    },
    { provide: FORMLY_CONFIG, multi: true, useFactory: registerTranslateExtension, deps: [TranslateService] },
    { provide: SETTINGS, useValue: { experimentalAutoDetectLongPolling: true, merge: true } },
    MsalGuard,
  ],
  bootstrap: [AppComponent, MsalRedirectComponent],
})
export class AppModule {}
